module.exports = __webpack_public_path__ + "img/pr-1.117b67a8.png";